import React, { useCallback, useState } from 'react'

import { type WidgetDTO } from '../../../../../model/Widget'

import {
  CalendlyEditMode,
  type CalendlyFormValues,
} from './edit/CalendlyEditMode'
import { CalendlyPreview } from './preview/CalendlyPreview'

import './WidgetCalendly.scss'

interface WidgetCalendlyProps {
  widget: WidgetDTO
  isEditable?: boolean
  onSave?: (values: Partial<WidgetDTO>) => Promise<void>
  onDelete?: () => void
  onCancel?: () => void
}

export const WidgetCalendly = ({
  widget,
  isEditable = false,
  onSave,
  onDelete,
  onCancel,
}: WidgetCalendlyProps) => {
  const [isEditMode, setIsEditMode] = useState(!!widget.empty_p)

  const handleEdit = useCallback(() => {
    setIsEditMode(true)
  }, [])

  const handleCancel = useCallback(() => {
    onCancel?.()
    if (!widget.empty_p) {
      setIsEditMode(false)
    }
  }, [onCancel, widget.empty_p])

  const handleSubmit = useCallback(
    async (values: CalendlyFormValues) => {
      await onSave?.({ link: values.link })
      setIsEditMode(false)
    },
    [onSave]
  )

  const handleDelete = useCallback(() => {
    onDelete?.()
  }, [onDelete])

  return isEditMode ? (
    <CalendlyEditMode
      widget={widget}
      onSave={handleSubmit}
      onCancel={handleCancel}
    />
  ) : (
    <CalendlyPreview
      widget={widget}
      isEditable={isEditable}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  )
}
